// extracted by mini-css-extract-plugin
export default {"container":"ProjectList_container__0gUVT","title":"ProjectList_title__uDR7t","containerTitle":"ProjectList_containerTitle__quoRK"};